import { render, staticRenderFns } from "./AvatarDisplay.vue?vue&type=template&id=353c5e8c"
import script from "./AvatarDisplay.vue?vue&type=script&lang=js"
export * from "./AvatarDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports